// removed by extract-text-webpack-plugin
module.exports = {"btn-record-payment":"app-components-receipt-invoices-ButtonGroup-__style___3ncM2","resend":"app-components-receipt-invoices-ButtonGroup-__style___1pgst","mr-btn":"app-components-receipt-invoices-ButtonGroup-__style___2Ie4s"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/invoices/ButtonGroup/style.css
// module id = 2002
// module chunks = 0